import React, { useEffect, useRef } from 'react';
import Shepherd from 'shepherd.js';

const ShepherdRunner = ({ steps, tourOptions, onComplete, onCancel, tourKey }) => {
  const tourInstanceRef = useRef(null);

  useEffect(() => {
    console.log(`[ShepherdRunner] Effect run. Key: ${tourKey}. Has steps: ${!!(steps && steps.length)}. Has options: ${!!tourOptions}`);

    // if (tourInstanceRef.current) { // Removed: Cleanup function handles prior instance
    // }

    if (steps && steps.length > 0 && tourOptions) {
      const tour = new Shepherd.Tour(tourOptions);
      tourInstanceRef.current = tour;

      steps.forEach(originalStep => {
        let stepToAdd = { ...originalStep };
        if (typeof originalStep.buttons === 'function') {
          // IMPORTANT: Button configurations are generated by functions from tutorialSteps.js
          // This allows button actions to be closures that correctly reference the live 'tour' instance (e.g., tour.next(), tour.cancel()).
          // Shepherd.js v11.2.0 (via its Svelte components) had issues with string-based actions ('next', 'cancel'),
          // leading to a 'TypeError: config.action.bind is not a function'.
          // Providing direct function references for actions resolved this.
          // console.log(`[ShepherdRunner] Processing function buttons for step: ${originalStep.id}`); // Optional: for deep debug
          stepToAdd.buttons = originalStep.buttons(tour);
        }
        tour.addStep(stepToAdd);
      });

      // Event listeners
      tour.on('error', (error) => {
        console.error('[ShepherdRunner] Shepherd Tour Error Event:', error);
        if (onCancel) onCancel();
        tourInstanceRef.current = null;
      });

      tour.on('complete', () => {
        console.log('[ShepherdRunner] Tour complete event.');
        if (onComplete) onComplete();
        tourInstanceRef.current = null;
      });

      tour.on('cancel', () => {
        console.log('[ShepherdRunner] Tour cancel event.');
        if (onCancel) onCancel();
        tourInstanceRef.current = null;
      });

      // tour.on('show', (event) => { // Optional: for very specific debugging
      //   console.log(`[ShepherdRunner] Step shown: ${event.step.id}`);
      // });

      const startTimeoutId = setTimeout(() => {
        if (tourInstanceRef.current === tour && !tour.isActive()) {
          try {
            console.log(`[ShepherdRunner] Calling delayed tour.start(). Tour ID: ${tour.id}`);
            tour.start();
          } catch (e) {
            console.error('[ShepherdRunner] Error starting delayed tour:', e);
            if (onCancel) onCancel();
            tourInstanceRef.current = null;
          }
        // } else if (tourInstanceRef.current === tour && tour.isActive()) { // Optional: for deep debug
          // console.log('[ShepherdRunner] Delayed start: Tour was already active. ID:', tour.id);
        // } else { // Optional: for deep debug
          // console.log('[ShepherdRunner] Delayed start: Tour instance changed or was cleaned up before start.');
        }
      }, 100);

      // console.log(`[ShepherdRunner] tour.start() for tour ${tour.id} scheduled with timeoutId ${startTimeoutId}`); // Too verbose

      (tour)._startTimeoutId = startTimeoutId;

    } else {
      // console.log('[ShepherdRunner] No steps or tourOptions provided, not starting tour.'); // Optional: for deep debug
      if (tourInstanceRef.current) { // If a tour existed from a previous render but now no steps/options
        if (tourInstanceRef.current.isActive()) {
            tourInstanceRef.current.cancel();
        }
        tourInstanceRef.current = null;
      }
    }

    return () => {
      const currentTourInstance = tourInstanceRef.current; // Capture before nullifying
      if (currentTourInstance && (currentTourInstance)._startTimeoutId) {
        clearTimeout((currentTourInstance)._startTimeoutId);
        // console.log(`[ShepherdRunner] Cleared tour.start() timeoutId ${(currentTourInstance)._startTimeoutId}`); // Optional: for deep debug
      }

      if (currentTourInstance) { // Use captured instance for cleanup
        console.log(`[ShepherdRunner] useEffect cleanup. Cancelling tour instance: ${currentTourInstance.id}`);
        if (currentTourInstance.isActive()) {
            currentTourInstance.cancel();
        }
        tourInstanceRef.current = null; // Nullify the ref itself
      }
    };
  }, [steps, tourOptions, onComplete, onCancel, tourKey]);

  return null;
};

export default ShepherdRunner;
